<template>
    <div>
        <section class="section">
            <div class="container">
                <app-input-image-widget
                    :multiple="multiple"
                    @change="handleImage"
                />
            </div>
        </section>
        <section class="section pt-6 mt-1">
            <div class="container">
                <div class="columns is-multiline">
                    <div
                        v-for="(image, index) in images"
                        :key="index"
                        class="column has-min-width-200 has-actions-inside"
                    >
                        <div>
                            <figure class="image">
                                <img :src="image | mediaSource" />
                            </figure>
                            <button
                                class="lb-delete-media"
                                @click.stop="removeImage(index)"
                            >
                                <span class="icon is-small">
                                    <i class="fas fa-trash" />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import _ from 'underscore';
import { upload } from '@/services/API';
import AppInputImageWidget from '@/components/AppInputImageWidget';
export default {
    name: 'InputImage',
    components: {
        AppInputImageWidget,
    },
    filters: {
        mediaSource(media) {
            if (typeof media === 'string') return media;
            if (typeof media === 'object') {
                if (_.isArray(media)) return media[0].url;
                else return media.url;
            }
        },
    },
    model: {
        prop: 'sourceImages',
    },
    props: {
        fromClipboard: { type: Boolean, default: false },
        sourceImages: {
            type: Array,
            default: () => {
                return [];
            },
        },
        multiple: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            colors: [],
            images: this.sourceImages || [],
        };
    },
    computed: {
        clipboardContent() {
            return this.$store.getters.clipboardContent;
        },
    },
    watch: {
        clipboardContent() {
            if (this.clipboardContent && this.clipboardContent.length) {
                _.each(this.clipboardContent, (image, i) => {
                    if (image instanceof File) {
                        this.handleImage([image]);
                    } else if (image.type.indexOf('image') !== -1) {
                        this.handleImage([image.getAsFile()]);
                    }
                });
                this.$store.dispatch('setClipboardContent', undefined);
            }
        },
    },
    mounted() {
        if (this.clipboardContent && this.clipboardContent.length) {
            _.each(this.clipboardContent, (image) => {
                console.log(
                    'mounted input image',
                    this.clipboardContent,
                    image.type.indexOf('image')
                );
                if (image.type.indexOf('image') !== -1) {
                    if (image instanceof File) {
                        this.handleImage([image]);
                    } else {
                        this.handleImage([image.getAsFile()]);
                    }
                }
            });
        }
    },
    methods: {
        async handleImage(files) {
            if (files.length == 0) {
                return;
            }
            this.$emit('uploading');
            let response = await upload(`images`, files).catch((err) => {
                return this.$emit('error', err);
            });
            if (response.data) {
                this.images = [...this.images, ...response.data.images];
                this.$emit('input', this.images);
            }
        },
        removeImage(position) {
            this.images.splice(position, 1);
            //this.$emit("update:images", this.images);
        },
    },
};
</script>

<style>
.has-min-width-200 {
    min-width: 200px;
    padding: 0;
    margin: 5px;
}
.has-actions-inside {
    position: relative;
}
</style>
